import { target, targetable } from "@github/catalyst/lib/targetable";
import { cropCanvasAndExportToPNG } from "../submission_form/crop_canvas";

export default targetable(
  class extends HTMLElement {
    static [target.static] = ["canvas", "input", "clear", "button"];

    async connectedCallback() {
      const scale = 3;

      // === Inisialisasi untuk Signature Draw ===
      if (this.canvas) {
        this.canvas.width = this.canvas.parentNode.clientWidth * scale;
        this.canvas.height = this.canvas.parentNode.clientHeight * scale;
        this.canvas.getContext("2d").scale(scale, scale);

        const { default: SignaturePad } = await import("signature_pad");
        this.pad = new SignaturePad(this.canvas);
        this.pad.penColor = "#000000";

        const colorSpans = this.querySelectorAll("[data-color]");
        colorSpans.forEach((span) => {
          span.addEventListener("click", () => {
            const selectedColor = span.dataset.color;
            this.pad.penColor = selectedColor;
            // Tambahkan logika visual untuk menandai warna yang aktif (opsional)
            colorSpans.forEach((s) => s.classList.remove("active-color")); // Hapus kelas aktif dari semua
            span.classList.add("active-color"); // Tambahkan kelas aktif ke yang dipilih
          });
        });

        if (this.clear) {
          this.clear.addEventListener("click", (e) => {
            e.preventDefault();
            this.pad.clear();
          });
        }

        if (this.button) {
          this.button.addEventListener("click", (e) => {
            e.preventDefault();
            this.button.disabled = true;
            this.submit(this.canvas);
          });
        }
      }

      // === Inisialisasi untuk Signature Text (Ttd) ===
      const buttonTtd = document.getElementById("ttdButton");
      const canvas2 = document.getElementById("canvas2");
      const signatureTextInput = document.getElementById("signature-text");
      const fontSelect = document.getElementById("font-select");
      const fontSizeInput = document.getElementById("input-font-size");
      const boldButton = document.getElementById("input-bold");
      const italicButton = document.getElementById("input-italic");
      const underlineButton = document.getElementById("input-underline");
      const textColorSpans = this.querySelectorAll("[data-color]");
      const buttonClear = document.getElementById("clearText");

      if (canvas2 && signatureTextInput && fontSelect && buttonTtd) {
        const ctx2 = canvas2.getContext("2d");
        if (!ctx2) return;

        this.canvasContext2 = ctx2;

        signatureTextInput.addEventListener("input", () =>
          this.updateCanvasText(canvas2, ctx2, fontSizeInput.value)
        );
        fontSelect.addEventListener("change", () =>
          this.updateCanvasText(canvas2, ctx2, fontSizeInput.value)
        );
        fontSizeInput.addEventListener("input", () =>
          // Event listener untuk perubahan ukuran font
          this.updateCanvasText(canvas2, ctx2, fontSizeInput.value)
        );

        boldButton.addEventListener("click", () => {
          this.isBold = !this.isBold;
          this.updateCanvasText(canvas2, ctx2, fontSizeInput.value);
        });

        italicButton.addEventListener("click", () => {
          this.isItalic = !this.isItalic;
          this.updateCanvasText(canvas2, ctx2, fontSizeInput.value);
        });

        underlineButton.addEventListener("click", () => {
          this.isUnderline = !this.isUnderline;
          this.updateCanvasText(canvas2, ctx2, fontSizeInput.value);
        });

        textColorSpans.forEach((span) => {
          span.addEventListener("click", () => {
            this.textColor = span.dataset.color;
            this.updateCanvasText(canvas2, ctx2, fontSizeInput.value);
            textColorSpans.forEach((s) =>
              s.classList.remove("active-text-color")
            );
            span.classList.add("active-text-color");
          });
        });

        buttonTtd.addEventListener("click", (e) => {
          e.preventDefault();
          buttonTtd.disabled = true;
          this.submit(canvas2);
        });

        if (buttonClear) {
          buttonClear.addEventListener("click", (e) => {
            e.preventDefault();
            signatureTextInput.value = "";
            this.isBold = false;
            this.isItalic = false;
            this.isUnderline = false;
            this.textColor = "#000000";
            ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
            this.updateCanvasText(canvas2, ctx2, fontSizeInput.value);
          });
        }
      }
    }

    updateCanvasText(canvas, ctx, fontSize) {
      const signatureTextInput = document.getElementById("signature-text");
      const fontSelect = document.getElementById("font-select");

      if (!canvas || !ctx || !signatureTextInput || !fontSelect) return;

      const text = signatureTextInput.value.trim();
      const selectedFont = fontSelect.value;
      const fontSizeNumber = parseInt(fontSize, 10); // Perubahan di sini

      let fontStyle = "";
      if (this.isBold) {
        fontStyle += "bold ";
      }
      if (this.isItalic) {
        fontStyle += "italic ";
      }

      ctx.textBaseline = "middle";
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = this.textColor;
      ctx.textAlign = "center";
      ctx.font = `${fontStyle}${fontSizeNumber}px ${selectedFont}`;
      ctx.fillText(text, canvas.width / 2, canvas.height / 2);

      if (this.isUnderline && text) {
        const textMetrics = ctx.measureText(text);
        const textWidth = textMetrics.width;
        const textHeight = fontSizeNumber; // Perkiraan tinggi teks
        const startX = (canvas.width - textWidth) / 2;
        const startY = canvas.height / 2 + textHeight / 3; // Posisi garis bawah

        ctx.lineWidth = 1; // Ketebalan garis bawah
        ctx.strokeStyle = this.textColor;
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(startX + textWidth, startY);
        ctx.stroke();
      }
    }

    async submit(selectedCanvas) {
      const blob = await cropCanvasAndExportToPNG(selectedCanvas);
      const file = new File([blob], "signature.png", { type: "image/png" });

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);

      if (this.input) {
        this.input.files = dataTransfer.files;

        if (this.input.webkitEntries.length) {
          this.input.dataset.file = `${dataTransfer.files[0].name}`;
        }
      }

      this.closest("form").requestSubmit();
    }
  }
);
